<script>
  import {
    DownloadIcon
  } from 'vue-feather-icons'

  export default {
    components: {
      DownloadIcon,
    },
    props: {
      hasBack: {
        type: Boolean,
        default: false,
      },
      backText:{
        type: String,
        default: 'Cancel',
      },
      hasCopy: {
        type: Boolean,
        default: false,
      },
      copyText:{
        type: String,
        default: 'Save Details',
      },
      copyDisplayName:{
        type: String,
        default: null,
      },
      hasDownload: {
        type: Boolean,
        default: false,
      },
      disableDownload:{
        type: Boolean,
        default: false,
      },
      hasStatus: {
        type: Boolean,
        default: false,
      },
      hasConfigurableStatus: {
        type: Boolean,
        default: false,
      },
      statusObjectParent:{
        type: Object,
        default: () => {},
      },
      statusCollection:{
        type: Function,
        default: () => ([]),
      },
      hasRhs: {
        type: Boolean,
        default: false,
      },
    },
    computed:{
      resolvedStatus(){
        if (this.statusObjectParent && this.statusObjectParent.status){
          return this.statusObjectParent.status
        }
        return {
          "key": "draft",
          "name": "Unknown"
        }
      }
    }
  }
</script>

<template>
  <header class="tw-flex tw-flex-col md:tw-flex-row align-items-center justify-content-between">
    <div class="md:tw-pl-4 tw-w-full md:tw-w-2/3 ml:tw-w-1/2 sm:tw-mr-u md:tw--mr-4 lg:tw-mr-u">
      <div>
        <a
          v-if="hasBack"
          href="javascript:void(0)"
          class="tw-text-primary hover:tw-text-primaryDarkened tw-no-underline hover:tw-underline hover:tw-decoration-primary"
          @click="$emit('header-back')"
        >&lt; {{ backText }}</a>
      </div>
      <h2
        v-if="hasCopy"
        class="
          tw-flex tw-flex-col md:tw-flex-row
          tw-items-center
          tw-mt-1 tw-mb-0
          tw-text-primary tw-text-xl tw-font-semibold tw-leading-relaxed"
      >{{ copyText }} <span v-if="copyDisplayName" class="col-black md:tw-pl-2">{{ copyDisplayName }}</span><slot name="custom-lhf-button" /></h2>
    </div>
    <div class="tw-flex tw-flex-row md:tw-flex-col xl:tw-flex-row justify-content-end tw-gap-x-4 tw-gap-y-1.5">
      <section v-if="hasRhs || hasDownload" class="tw-flex tw-flex-col ml:tw-flex-row tw-gap-x-4 tw-gap-y-1.5">
        <slot v-if="hasRhs" name="custom-rhs-button" />
        <button
          v-if="hasDownload"
          type="button"
          class="btn btn-default text-uppercase tw-hidden md:tw-flex"
          :disabled="disableDownload"
          @click="$emit('header-download')">
          <div class="tw-flex align-items-center">
            Download PDF <DownloadIcon size="1.1x" class="ml-2 font-weight-bold"/>
          </div>
        </button>
      </section>
      <div
        v-if="hasStatus"
        class="status-steps tw-flex align-items-center">
        <slot name="xero-sync" />
        <div
          v-if="hasConfigurableStatus"
          class="dropdown-default-line md:tw-pl-3">
          <BaseStatusSelect
            v-model="statusObjectParent.status"
            :get-statuses="statusCollection"
          />
        </div>
        <BaseDocumentStatusBar
          v-else
          :status="resolvedStatus" />
      </div>
    </div>
  </header>
</template>
